import { useEffect, useRef, useState } from "react";
import { ready } from "@/lib/clerk";

/**
 * Clerk's Email Code sign-in, mounted into a plain element, with the two
 * options Home found it cannot do without.
 */
export function SignIn() {
  const ref = useRef<HTMLDivElement>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let mounted: HTMLDivElement | null = null;
    void ready().then((clerk) => {
      if (!clerk || !ref.current) {
        setFailed(true);
        return;
      }
      mounted = ref.current;
      // Back to the page the person asked for, e.g. a brief linked from an email.
      const here = `${window.location.origin}${window.location.pathname}${window.location.search}`;
      clerk.mountSignIn(mounted, {
        /**
         * ⚠ `virtual` routing, not the default `path`. With path routing the
         * widget navigates to the instance's sign-in URL, which is the Account
         * Portal at accounts.leychoon.app, and the portal sends the browser back:
         * a loop. Virtual keeps the whole flow inside this node (Home learnt it).
         */
        routing: "virtual",
        /**
         * ⚠ Forced, and absolute. The instance's after_sign_in_url points at
         * sso.leychoon.app, a different app; without this a successful sign-in
         * here hands the person to it.
         */
        forceRedirectUrl: here,
        fallbackRedirectUrl: here,
      });
    });
    return () => {
      if (mounted) window.Clerk?.unmountSignIn(mounted);
    };
  }, []);

  return (
    <main className="mx-auto grid min-h-dvh max-w-md place-items-center px-6 py-10">
      <div className="w-full text-center">
        <img src="/logo.svg" alt="" width={48} height={48} className="mx-auto mb-4 rounded-xl" />
        <h1 className="text-lg font-semibold">Solution Brief</h1>
        <p className="text-muted-foreground mt-1 mb-6 text-sm">Sign in with your Ley Choon email.</p>
        <div ref={ref} className="flex justify-center" />
        {failed ? (
          <p className="text-muted-foreground mt-4 text-sm">
            Sign-in could not load. Check your connection and try again.
          </p>
        ) : null}
      </div>
    </main>
  );
}
